module.exports = __webpack_public_path__ + "img/bn0706.cf68aac3.png";